import { render, staticRenderFns } from "./render.vue?vue&type=template&id=108f5be0&scoped=true"
import script from "./render.vue?vue&type=script&lang=js"
export * from "./render.vue?vue&type=script&lang=js"
import style0 from "./render.vue?vue&type=style&index=0&id=108f5be0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108f5be0",
  null
  
)

export default component.exports